import { ToastController } from 'ionic-angular';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomToast{

	toastCtrl : ToastController;

	constructor(toastCtrl : ToastController){
		this.toastCtrl = toastCtrl;
	}

	showMessage(message,time){
		this.toastCtrl.create({
	        position : 'top',
	        message: message,
	        duration: time ? time : 4000
      	}).present();
	}
}


// WEBPACK FOOTER //
// ./src/util/CustomToast.ts